import { Outlet, createFileRoute } from "@tanstack/react-router";

const AuthLayout = () => {
  return (
    <div className="h-full bg-black bg-[url('../../iniciador_lines.png')] bg-contain bg-bottom-right bg-no-repeat">
      <div className="flex h-full w-full flex-col items-center justify-center">
        <Outlet />
      </div>
    </div>
  );
};

export const Route = createFileRoute("/(auth)")({
  component: AuthLayout,
});
